import React from 'react';
import { Global } from '@emotion/react';
import { rem, em } from './utils/rem/rem.js';

function assignSizeVariables(variables, sizes, name, targetUnitConverter = rem) {
  Object.keys(sizes).forEach((size) => {
    variables[`--mantine-${name}-${size}`] = targetUnitConverter(sizes[size]);
  });
}
function MantineCssVariables({ theme }) {
  const variables = {
    "--mantine-color-white": theme.white,
    "--mantine-color-black": theme.black,
    "--mantine-transition-timing-function": theme.transitionTimingFunction,
    "--mantine-line-height": `${theme.lineHeight}`,
    "--mantine-font-family": theme.fontFamily,
    "--mantine-font-family-monospace": theme.fontFamilyMonospace,
    "--mantine-font-family-headings": theme.headings.fontFamily,
    "--mantine-heading-font-weight": `${theme.headings.fontWeight}`
  };
  assignSizeVariables(variables, theme.shadows, "shadow");
  assignSizeVariables(variables, theme.fontSizes, "font-size");
  assignSizeVariables(variables, theme.radius, "radius");
  assignSizeVariables(variables, theme.spacing, "spacing");
  assignSizeVariables(variables, theme.breakpoints, "breakpoints", em);
  Object.keys(theme.colors).forEach((color) => {
    theme.colors[color].forEach((shade, index) => {
      variables[`--mantine-color-${color}-${index}`] = shade;
    });
  });
  const headings = theme.headings.sizes;
  Object.keys(headings).forEach((heading) => {
    variables[`--mantine-${heading}-font-size`] = headings[heading].fontSize;
    variables[`--mantine-${heading}-line-height`] = `${headings[heading].lineHeight}`;
  });
  return /* @__PURE__ */ React.createElement(Global, {
    styles: {
      ":root": variables
    }
  });
}

export { MantineCssVariables };
//# sourceMappingURL=MantineCssVariables.js.map
